<template>
    <div class="utility-callout-wrapper w-largeDesktop ml-auto mr-auto flex items-center px-spc15 mb-spc16">
        <div class="callout-item pr-5 lg:text-left sm:text-center sm:flex-1">
            <h1 class="callout-title flex items-end text-size28 font-semibold text-primary h-12 lg:justify-start sm:justify-center">
                88 <span>cu ft</span>
            </h1>
            <p class="callout-desc text-xs font-medium leading-spc3 lg:block sm:hidden">
                Best in class storage, with more cargo room than most sport utility vehicles
            </p>
            <p class="rp callout-desc text-xs font-medium leading-spc3 lg:hidden sm:block">
                Best in class <br>storage
            </p>
        </div>
        <div class="callout-item px-5 lg:text-left sm:text-center sm:flex-1">
            <h1 class="callout-title flex items-center text-size28 font-semibold text-primary h-12 lg:justify-start sm:justify-center">
                <svg width="40px" height="41px" viewBox="0 0 40 41" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>MX_room-for-7</title>
                    <desc>Created with Sketch.</desc>
                    <g id="MX_room-for-7" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(0.000000, 1.000000)">
                        <g id="seat" transform="translate(7.000000, 7.000000)" fill="#171a20" fill-rule="nonzero">
                            <path d="M4.81,26 C4.68,26 4.68,26 4.81,26 L1.04,25.74 C0.65,25.74 0.26,25.48 0.13,25.09 C5.06539255e-16,24.7 4.64905892e-16,24.44 0.13,24.05 L5.98,15.6 C6.63,14.56 7.8,13.91 9.1,13.91 L13.26,13.91 L17.68,7.41 C16.77,6.63 16.25,5.46 16.25,4.29 C16.38,1.95 18.2,0 20.54,0 C22.88,0 24.83,1.95 24.83,4.29 C24.83,5.46 24.31,6.63 23.53,7.41 C24.31,9.1 24.31,11.05 23.14,12.61 L17.16,21.06 C16.9,21.45 16.51,21.58 16.12,21.45 L10.92,20.41 C10.53,20.28 10.27,20.41 10.01,20.67 L5.46,25.61 C5.33,25.87 5.07,26 4.81,26 L4.81,26 Z M2.99,23.79 L4.29,23.92 L8.45,19.37 C9.23,18.59 10.27,18.2 11.31,18.46 L15.73,19.37 L21.32,11.57 C22.1,10.53 21.97,8.97 21.19,8.06 C20.93,7.8 20.93,7.54 20.93,7.15 C20.93,6.89 21.19,6.5 21.45,6.37 C22.1,5.98 22.62,5.33 22.62,4.55 C22.62,3.38 21.71,2.47 20.54,2.47 C19.37,2.47 18.46,3.38 18.46,4.55 C18.46,5.33 18.98,6.11 19.63,6.5 C19.89,6.63 20.15,6.89 20.15,7.15 C20.28,7.41 20.15,7.8 20.02,8.06 L14.56,15.86 C14.3,16.12 14.04,16.38 13.65,16.38 L9.1,16.38 C8.58,16.38 8.06,16.64 7.8,17.03 L2.99,23.79 Z" id="Shape"></path>
                            <path d="M18.85,25.48 C18.72,25.48 18.46,25.35 18.33,25.22 L12.87,15.34 C12.74,15.08 12.87,14.69 13.13,14.56 C13.39,14.43 13.78,14.56 13.91,14.82 L19.37,24.7 C19.5,24.96 19.37,25.35 19.11,25.48 L18.85,25.48 Z M16.12,12.22 C15.86,12.22 15.73,12.09 15.6,11.83 C15.47,11.57 15.73,11.31 15.99,11.18 L26.65,8.06 C26.91,7.93 27.17,8.19 27.3,8.45 C27.43,8.71 27.17,8.97 26.91,9.1 L16.25,12.22 L16.12,12.22 Z" id="Shape"></path>
                        </g>
                    </g>
                </svg>
                <span class="pl-1">7</span>
            </h1>
            <p class="callout-desc text-xs font-medium leading-spc3 lg:block sm:hidden">
                Maximum passenger and cargo capacity, with seating for up to seven adults
            </p>
            <p class="rp callout-desc text-xs font-medium leading-spc3 lg:hidden sm:block">
                Seating <br>for seven
            </p>
        </div>
        <div class="callout-item pl-5 lg:text-left sm:text-center sm:flex-1">
            <h1 class="callout-title flex items-center text-14 h-12 lg:justify-start sm:justify-center">
                <img src="../../../assets/images/MX_falcon-wings.svg" alt="man sit">
                <span class="lg:block sm:hidden text-14 font-medium pl-1">Falcon Wing <br>Doors</span>
            </h1>
            <p class="callout-desc text-xs font-medium leading-spc3 lg:block sm:hidden">
                Enhances accessibility to back rows and opens in the tightest parking spaces
            </p>
            <p class="rp callout-desc text-xs font-medium leading-spc3 lg:hidden sm:block">
                Falcon Wing <br>Doors
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "UtilitySpecs"
    }
</script>

<style scoped>

</style>